import script from "./TransactionFailed.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionFailed.vue?vue&type=script&setup=true&lang=js"

import "./TransactionFailed.vue?vue&type=style&index=0&id=87e8cf04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e8cf04"]])

export default __exports__